<template>
	<view class="floating-label-wrapper">
		<view :class="['label', props.modelValue ? 'active' : '' ]">
			<text>{{ props.label }}</text>
			<text v-if="props.required" class="text-[#FF4D4F]">*</text>
		</view>
		<view class="flex justify-between items-center" @click="show = true">
			<view class="input-container">{{ showValue || props.modelValue }}</view>
			<view class="flex-1 flex items-center justify-end">
				<up-icon name="arrow-right"></up-icon>
			</view>
		</view>

		<up-picker :closeOnClickOverlay="true" :show="show" :columns="[props.columns]"
			:keyName="props.keyName" :cancelText="t('common.cancel')" :confirmText="t('common.confirm')" @confirm="confirm"
			@cancel="show = false"></up-picker>
	</view>
</template>

<script setup>
	import {
		ref,
		reactive,
		defineProps,
		onMounted,
		computed
	} from 'vue'
	import {
		useI18n
	} from 'vue-i18n'
	const {
		t
	} = useI18n()

	const props = defineProps({
		columns: Array,
		required: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		modelValue: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		keyName: {
			type: String,
			default: 'label'
		},
	})

	const emit = defineEmits(['update:modelValue'])

	const show = ref(false);
	const showValue = computed(() => {
		return props.columns.find((v) => props.modelValue === v.value)?.[props.keyName]
	});
	const confirm = (e) => {
		emit("update:modelValue", e.value[0].value)
		emit("change", e.value[0])
		show.value = false
	}
</script>

<style scoped>
	.floating-label-wrapper {
		position: relative;
		border-bottom: 2rpx solid #eee;
	}

	.floating-label-wrapper .label {
		position: absolute;
		top: 50%;
		left: 10px;
		z-index: 10;
		color: #808080;
		transform: translateY(-20rpx);
		transition: all 0.3s ease;
		pointer-events: none;
	}

	.floating-label-wrapper .active {
		top: 0;
		font-size: 24rpx;
		color: #808080;
	}

	.input-container {
		display: flex;
		align-items: flex-end;
		height: 40rpx;
		padding: 36rpx 20rpx 16rpx;
	}
</style>